export const LAST_HDR_SKY = 'LAST_HDR_SKY';